import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';

export default class ChangeBranchToExternal extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    branchShortName: PropTypes.string,
    headerNode: PropTypes.node,
    modalType: PropTypes.shape({
      isProjectOwner: PropTypes.bool,
      isHigherAccess: PropTypes.bool,
    }).isRequired,
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnComfirm = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e);
    }
  }
  render() {
    return (
      <Modal
        basic
        open={this.props.open === true}
        onClose={this.handleOnClose}
      >
        <Header icon="warning sign" content={this.props.headerNode || 'Confirm set business unit as agency?'} />
        <Modal.Content>
          <Modal.Description>
            { this.props.modalType.isHigherAccess &&
              <p>This will downgrade all staffs in <strong>{this.props.branchShortName || 'business unit'}</strong> to agent access level.</p>
            }
            { this.props.modalType.isProjectOwner &&
              <p>This will remove all projects ownership from <strong>{this.props.branchShortName || 'business unit'}</strong>.</p>
            }
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button basic negative onClick={this.handleOnClose} icon="cancel" content="Cancel" inverted />
          <Button basic positive onClick={this.handleOnComfirm} icon="checkmark" content="Confirm" inverted />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/ChangeBranchToExternal.jsx